// The decision-button row's gaps (2026-10-12; DecisionButtonRow.jsx): the same
// horizontal gap as before (MUI spacing 0.75) and a clearly larger vertical
// gap between wrapped lines (1.5, about 12px), so the button under Send is
// harder to hit by mistake.
export const DECISION_BUTTON_ROW_GAPS = Object.freeze({ columnGap: 0.75, rowGap: 1.5 })
